import React, { useState } from 'react';


const PopUpHappy = (props) => {

    const [open, setOpen] = useState(true);

    return (
        <div className={"loginPage"}>

            {(props.topSlides != null) ?
                props.topSlides : ""
            }
            <div className="firstMastSec">
                <div className="insideFrame spaceMargBottomVeryBig">
                    {props.Title.map((txtItm, index) => (
                        <span className="huge arrowing fullRow" key={index}>{txtItm}</span>
                    ))}
                </div>
                {props.ContentText.map((txtItm, index) => {
                    return (
                        <span key={index} className="big oopsTxt">{txtItm.txt}<br /></span>
                    )
                })}
                {props.okClick1 ?
                    <div className="fullRow spaceMargBottomVeryBig">

                        <div className="fullRow">
                            <div className="connectBtn conClear bold big pointing"
                                onClick={() => props.okClick1()}>{props.okTxt1 || 'המשך'}</div>
                        </div>
                    </div>

                    :
                    <div className="fullRow">

                        <div className="fullRow">
                            <div className="connectBtn conClear bold big pointing"
                                onClick={() => props.okClick()}>המשך</div>
                        </div>
                    </div>

                }
                {props.okClick2 &&
                    <div className="fullRow">
                        <div className="fullRow">
                            <div className="connectBtn conClear bold big pointing"
                                onClick={() => props.okClick2()}>{props.okTxt2 || 'חזור'}</div>
                        </div>
                    </div>
                }


            </div>
        </div>

    );
}

export default PopUpHappy;